import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Billing Toggle',
    inputs: [
        {
            name: 'stateKey',
            type: 'string',
            required: true,
            defaultValue: 'showMonthlyPrice',
            helperText: 'The key of the state to toggle in Builder.io',
        },
        {
            name: 'label1',
            type: 'string',
            required: true,
            defaultValue: 'Monthly',
            helperText: 'Label for the monthly option. Reported as pricing.billing_toggle.monthly when picked.',
        },
        {
            name: 'label2',
            type: 'string',
            required: true,
            defaultValue: 'Annual',
            helperText: 'Label for the annual option. Reported as pricing.billing_toggle.annual when picked.',
        },
        {
            name: 'extraMessage',
            type: 'string',
            required: false,
            defaultValue: 'SAVE UP TO 40%',
            helperText: 'Optional extra message to display.',
        },
    ],
};
